// Light/dark switch, shown as an item in the account menu so it stays out of the
// way (the console is light unless the user picks dark). The label names the
// mode it switches to: "Dark mode" while light, "Light mode" while dark.
import { useState } from "react";
import { Moon, Sun } from "lucide-react";
import { resolveTheme, setTheme, type Theme } from "../theme";

export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(resolveTheme);

  function toggle() {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    setThemeState(next);
  }

  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button type="button" role="menuitem" className="account-menu-item" onClick={toggle}>
      <Icon size={14} aria-hidden="true" /> {theme === "dark" ? "Light mode" : "Dark mode"}
    </button>
  );
}
